import React from 'react';
import { ICorrectText } from '@/types';

/** AI 文本类解析 */
interface IProps {
    data: ICorrectText;
}

const colors = ['#ff4d4d', '#00c887', 'black', 'black'];
const colorBgs = ['#fae5e4', '#dff6ed', '', '']; // bg red green

const deleteEntry = (content: string) => {
    // 使用正则表达式检查字符串末尾是否为 \n
    if (/\n$/.test(content)) {
        // 如果末尾是 \n，则去掉它
        const modifiedAaa = content.slice(0, -1);
        return modifiedAaa;
    }
    return content;
};

const CpaCorrectText: React.FC<IProps> = ({ data }) => {
    // 拼接答案，并根据 score 设置样式
    const renderedAnswers =
        data &&
        data.correctPointList.map(({ answer, score, showStatus }, index) => (
            <span className="answerContent" key={`${Date.now() + index}`} style={{ color: colors[showStatus] }}>
                {deleteEntry(answer)}
                <span className="aiAnswerScoreCpa" style={{ color: colors[showStatus], backgroundColor: colorBgs[showStatus] }}>
                    {showStatus <= 1 ? score + '分' : ''}
                </span>
                &nbsp;
            </span>
        ));

    return <div className="ai-match-content">{renderedAnswers}</div>;
};

export default CpaCorrectText;
